module.exports = __webpack_public_path__ + "static/media/dias.17061f10.png";